import React, { ChangeEvent, useState } from 'react';
import { PlusCircle, Search } from 'lucide-react';
import { useDebounceCallback } from 'usehooks-ts';
import { Button } from '@/Components/shadcn/button';
import { Input } from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';
import { useTeamMembersContext } from '../Context/TeamMembersContext';
import TeamMemberAddDialog from './TeamMemberAddDialog';

type CustomOnChangeHandler = (event: ChangeEvent<HTMLInputElement>) => void;

const TeamMembersActionBar = () => {
    const { searchTeamMember } = useTeamMembersContext();
    const [openDialog, setOpenDialog] = useState(false);
    const handleCloseDialog = () => setOpenDialog(false);
    const handleInviteNewMembers = () => setOpenDialog(true);

    const handleOnChange = useDebounceCallback<CustomOnChangeHandler>((event: ChangeEvent<HTMLInputElement>) => {
        searchTeamMember(event.target.value);
    }, 200);

    return (
        <div className="flex flex-row items-center justify-between gap-4">
            <div className="relative w-full max-w-md">
                <Search className="text-muted-foreground pointer-events-none absolute top-3 left-3 size-4" />
                <Input
                    className="bg-background pl-10"
                    placeholder={UIStrings.SearchByNameOrEmail}
                    onChange={handleOnChange}
                    aria-label={UIStrings.SearchByNameOrEmail}
                />
            </div>
            <Button type="button" variant="default-outline-transparent" onClick={handleInviteNewMembers}>
                <PlusCircle className="mr-2 size-4" />
                {UIStrings.InviteNewMembers}
            </Button>
            <TeamMemberAddDialog open={openDialog} onClose={handleCloseDialog} />
        </div>
    );
};

export default TeamMembersActionBar;
